import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import DocBug from './../../../../../../components/docBug';
import messages from '../../../../../../text/messages';
import selectOptions from '../../../../../../text/selectOptions';
import { required } from '../../../../../../utilities/validation';
import { SelectField, TextField } from '../../../../../../components/fields';
import { DOCUMENT_TYPES } from './../../../../../../components/document/types';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAdmin } from '../../../../../../reducers/onboarding';
import { updateUserDetails } from '../../../../../../reducers/identity';
import { parseAnswers, objectToFormInstanceValues, answersToSimpleInitialValues } from '../../../../../../utilities/formInstances';
import mixpanel from 'mixpanel-browser';
class TaxDocumentsStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'TaxDocumentsStep' } });

        const { admin, client, getAdmin } = this.props;
        if (!admin) getAdmin(client.admin_id);
    }

    submit(values, action) {
        const { details, role, updateUserDetails } = this.props;
        const { w9_fields } = values;

        const answers = parseAnswers(
            'w9_fields',
            [{ id: 'taxClassification' }, { id: 'exemptPayeeCode' }, { id: 'exemptFatcaCode' }],
            objectToFormInstanceValues(w9_fields)
        );

        updateUserDetails(role, { ...details, w9_fields: { answers } }, action);
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, details } = this.props;
        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'ICW9.introText'}
                            defaultMessage={'Please certify your tax ID number so we can issue you a proper 1099 at year end.'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="row w9-sub-title">Federal Tax Classification</div>
                    <div className="row">
                        <div className="col-xs-9">
                            <div className="col-xs-8">
                                <Field
                                    name="w9_fields.taxClassification"
                                    validate={required}
                                    component={SelectField}
                                    options={selectOptions.fedTaxClassTypes}
                                    placeholder={messages.taxClassification}
                                />
                            </div>
                            <div className="col-xs-4">
                                <span className="w9_fields.ein"> EIN </span> <br />
                                {details.tax_id}
                            </div>
                        </div>
                    </div>
                    <div className="row w9-sub-title">Exemptions (codes apply only to certain entities, not individuals)</div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="col-xs-6">
                                <Field name="w9_fields.exemptPayeeCode" component={TextField} placeholder={messages.exemptPayeeCode} />
                            </div>
                            <div className="col-xs-6">
                                <Field name="w9_fields.exemptFatcaCode" component={TextField} placeholder={messages.exemptFatcaCode} />
                            </div>
                        </div>
                    </div>
                </div>

                <DocBug docType={DOCUMENT_TYPES.W9FORM} adminId={admin && admin.id} />

                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

TaxDocumentsStep = reduxForm(formSettings)(TaxDocumentsStep);

const mapStateToProps = state => {
    let details = state.identity.details;
    return {
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        details,
        initialValues: {
            w9_fields: details.w9_fields ? answersToSimpleInitialValues(details.w9_fields.answers) : undefined
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            updateUserDetails: updateUserDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TaxDocumentsStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/taxDocuments.jsx